/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  successAlert,
  dublicateAlert,
  errorAlert,
  getReturnItem,
  yup,
} from '../Shared';
import { GContextTypes } from '../types';
import { GlobalContext } from '../contexts';
import PopupLayout from '../pages/main/PopupLayout';
import { Card, Grid, Typography } from '@material-ui/core';
import { CalenderLocal, TextFieldLocal } from '../components';
import { ImageOnlineUpload, uploadPhotoOnline } from '../common/upload';
import { useCategories, useTemplate } from '../hooks';
import AutoFieldLocal from '../components/fields/AutoFieldLocal';
import { useLazyQuery } from '@apollo/client';
import { getRentitemsReport } from '../graphql';
import { getYearsQtyFrom } from '../common/helpers';
import { moneyFormatEmpty } from '../Shared/colorFormat';

const PopupRentitem = ({
  open,
  onClose,
  row,
  isNew,
  setNewValue,
  addAction,
  editAction,
  newtext,
  theme,
}: any) => {
  const [saving, setSaving] = useState(false);
  const [catvalue, setCatvalue] = useState<any>(null);
  const [selectedDate, setSelectedDate] = React.useState(new Date());

  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [logoimage, setLogoimage] = useState(null);
  const [logourl, setLogourl] = useState(null);
  const { categories } = useCategories();

  const { register, handleSubmit, errors, reset } = useForm(yup.itmResolver);
  const {
    translate: { words, isRTL },
    store: { user },
  }: GContextTypes = useContext(GlobalContext);
  const { tempoptions } = useTemplate();

  const [fetchRentitemsReport, { data: sumData }] = useLazyQuery(
    getRentitemsReport,
    {
      fetchPolicy: 'network-only',
    }
  );

  useEffect(() => {
    if (row?._id) {
      fetchRentitemsReport({ variables: { itemIds: [row._id] } });
    }
  }, [row?._id]);

  const data = sumData?.['getRentitemsReport']?.data
    ? JSON.parse(sumData['getRentitemsReport'].data)
    : null;

  const calculatedValues = useMemo(() => {
    if (!data || !row) return null;

    const yearsFromPurchase = getYearsQtyFrom(row?.purchaseDate);
    const timedepreciation = (row?.yeardepreciation || 0) * yearsFromPurchase;
    const rentdepreciation =
      (row?.rentdepreciation || 0) * (data?.[0]?.totalqty || 0);
    const totalincome = (row?.price || 0) * (data?.[0]?.totalqty || 0);
    const totaldepreciation = rentdepreciation + timedepreciation;
    const remaining = (row?.rentitemcost || 0) - totaldepreciation;

    return {
      name: row?.name || '',
      nameAr: row?.nameAr || '',
      rentitemcost: row?.rentitemcost || 0,
      totalqty: data?.[0]?.totalqty || 0,
      timedepreciation,
      rentdepreciation,
      totalincome,
      totaldepreciation,
      remaining,
    };
  }, [data, row]);

  useEffect(() => {
    if (row?._id) {
      if (row?.photo) {
        setLogourl(row?.photo);
      }
      if (row?.categoryId) {
        const depart = categories.filter(
          (dep: any) => dep._id === row.categoryId
        )[0];
        setCatvalue(depart);
      }
      if (row?.purchaseDate) {
        const d = new Date(row?.purchaseDate);
        setSelectedDate(d);
      }
    }
  }, [row]);

  const handleDateChange = (date: any) => {
    if (date) {
      const d = new Date(date);
      setSelectedDate(d);
    }
  };

  const resetAll = () => {
    reset();
    setLogoimage(null);
    setCatvalue(null);
    setLogourl(null);
  };

  const onSubmit = async (data: any) => {
    setSaving(true);
    const name = data.name.trim();
    const nameAr = !tempoptions?.nameonelang ? data.nameAr.trim() : name;
    const {
      price,
      qty,
      unit,
      desc,
      barcode,
      rentitemcost,
      yeardepreciation,
      rentdepreciation,
    } = data;
    let photo: any;

    if (logoimage) {
      photo = await uploadPhotoOnline(logoimage);
      photo = photo.replace('http://', 'https://');
    }
    const category = catvalue
      ? {
          categoryId: catvalue._id,
          categoryName: catvalue.name,
          categoryNameAr: catvalue.nameAr,
        }
      : {
          categoryId: undefined,
          categoryName: undefined,
          categoryNameAr: undefined,
        };

    const variables: any = {
      _id: row && row._id ? row._id : undefined,
      itemType: 4,
      barcode: barcode?.length > 0 ? barcode : undefined,
      name,
      nameAr,
      category,
      price: Number(price),
      qty: Number(qty),
      unit,
      desc,
      photo,
      rentitemcost: Number(rentitemcost),
      yeardepreciation: Number(yeardepreciation),
      rentdepreciation: Number(rentdepreciation),
      purchaseDate: selectedDate ? new Date(selectedDate) : undefined,
      userId: user._id,
    };
    const mutate = isNew ? addAction : editAction;
    const mutateName = isNew ? 'createItem' : 'updateItem';
    await apply(mutate, mutateName, variables);
  };

  const apply = async (mutate: any, mutateName: string, variables: any) => {
    try {
      const res = await mutate({ variables });
      if (res?.data?.[mutateName]?.ok === false) {
        await errorAlert(setAlrt, isRTL);
        setSaving(false);
        return;
      }
      const nitem = getReturnItem(res, mutateName);
      if (setNewValue && nitem) setNewValue(nitem, 'item');

      await successAlert(setAlrt, isRTL);
      closeModal();
    } catch (error) {
      onError(error);
    }
  };

  const onError = async (error: any) => {
    if (error.message.includes('duplicate')) {
      await dublicateAlert(setAlrt, isRTL);
    } else {
      await errorAlert(setAlrt, isRTL);
      resetAll();
      console.log(error);
    }
  };

  const closeModal = () => {
    onClose();
    resetAll();
    setSaving(false);
  };

  const onHandleSubmit = () => {
    handleSubmit(onSubmit)();
  };
  const title = isRTL
    ? isNew
      ? 'بند تأجير جديدة'
      : 'تعديل بند تأجير'
    : isNew
    ? 'New Rent Item'
    : 'Edit Rent Item';
  return (
    <PopupLayout
      isRTL={isRTL}
      open={open}
      onClose={closeModal}
      title={title}
      onSubmit={onHandleSubmit}
      theme={theme}
      alrt={alrt}
      saving={saving}
      maxWidth="md"
    >
      <Grid container spacing={2}>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <ImageOnlineUpload
                url={logourl}
                setUrl={setLogourl}
                image={logoimage}
                setImage={setLogoimage}
                width={150}
                height={150}
                size="400x400"
              ></ImageOnlineUpload>
            </Grid>
            <Grid item xs={8}>
              <Grid container spacing={2}>
                {tempoptions?.barcode && (
                  <Grid item xs={12}>
                    <TextFieldLocal
                      autoFocus={tempoptions?.barcode}
                      name="barcode"
                      label={words.code}
                      register={register}
                      errors={errors}
                      row={row}
                      fullWidth
                      mb={0}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <TextFieldLocal
                    autoFocus={!tempoptions?.barcode}
                    required
                    name="name"
                    label={words.name}
                    register={register}
                    errors={errors}
                    row={row}
                    fullWidth
                    mb={0}
                  />
                </Grid>
                {!tempoptions?.nameonelang && (
                  <Grid item xs={12}>
                    <TextFieldLocal
                      required
                      name="nameAr"
                      label={words.nameAr}
                      register={register}
                      errors={errors}
                      row={row}
                      fullWidth
                      mb={0}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <AutoFieldLocal
                    name="category"
                    title={words?.category}
                    words={words}
                    options={categories.filter((dep: any) => dep.catType === 4)}
                    value={catvalue}
                    setSelectValue={setCatvalue}
                    register={register}
                    isRTL={isRTL}
                    fullWidth
                    mb={0}
                  ></AutoFieldLocal>
                </Grid>
                <Grid item xs={4}>
                  <TextFieldLocal
                    required
                    name="price"
                    label={words.theprice}
                    register={register}
                    errors={errors}
                    type="number"
                    row={row}
                    fullWidth
                    mb={0}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextFieldLocal
                    required
                    name="qty"
                    label={words.qty}
                    register={register}
                    errors={errors}
                    type="number"
                    row={row}
                    fullWidth
                    mb={0}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextFieldLocal
                    name="unit"
                    label={words.unit}
                    register={register}
                    errors={errors}
                    row={row}
                    newtext={newtext}
                    fullWidth
                    mb={0}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={4}>
              <TextFieldLocal
                name="rentitemcost"
                label={isRTL ? 'قيمة البند' : 'Rent Item Cost'}
                register={register}
                errors={errors}
                type="number"
                row={row}
                fullWidth
                mb={0}
              />
            </Grid>
            <Grid item xs={4}>
              <TextFieldLocal
                name="yeardepreciation"
                label={isRTL ? 'اهلاك سنوي' : 'Year Depreciation'}
                register={register}
                errors={errors}
                type="number"
                row={row}
                fullWidth
                mb={0}
              />
            </Grid>
            <Grid item xs={4}>
              <TextFieldLocal
                name="rentdepreciation"
                label={isRTL ? 'اهلاك التأجير' : 'Rent Depreciation'}
                register={register}
                errors={errors}
                type="number"
                row={row}
                fullWidth
                mb={0}
              />
            </Grid>
            <Grid item xs={12}>
              <CalenderLocal
                isRTL={isRTL}
                label={isRTL ? 'تاريخ الشراء' : 'Purchase Date'}
                value={selectedDate}
                onChange={handleDateChange}
                clock
              ></CalenderLocal>
            </Grid>

            <Grid item xs={12}>
              <TextFieldLocal
                name="desc"
                label={words.description}
                register={register}
                errors={errors}
                row={row}
                fullWidth
                multiline
                rowsMax={4}
                rows={4}
              />
            </Grid>
            <Grid item xs={12}>
              <Card style={{ padding: 10 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">
                          {isRTL ? 'عدد التأجير' : 'Total Rents'}
                        </Typography>
                        <Typography variant="subtitle1">
                          {calculatedValues?.totalqty || '0'}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">
                          {isRTL ? 'الاهلاك السنوي' : 'Yearly Depreciation'}
                        </Typography>
                        <Typography variant="subtitle1">
                          {moneyFormatEmpty(
                            calculatedValues?.timedepreciation
                          ) || '0'}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">
                          {isRTL ? 'اهلاك التأجير' : 'Rent Depreciation'}
                        </Typography>
                        <Typography variant="subtitle1">
                          {moneyFormatEmpty(
                            calculatedValues?.rentdepreciation
                          ) || '0'}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">
                          {isRTL ? 'اجمالي الدخل' : 'Total Income'}
                        </Typography>
                        <Typography variant="subtitle1">
                          {moneyFormatEmpty(calculatedValues?.totalincome) ||
                            '0'}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">
                          {isRTL ? 'اجمالي الاهلاك' : 'Total Depreciation'}
                        </Typography>
                        <Typography variant="subtitle1">
                          {moneyFormatEmpty(
                            calculatedValues?.totaldepreciation
                          ) || '0'}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">
                          {isRTL ? 'المتبقي' : 'Remaining Value'}
                        </Typography>
                        <Typography variant="subtitle1">
                          {moneyFormatEmpty(calculatedValues?.remaining) || '0'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
    </PopupLayout>
  );
};

export default PopupRentitem;
